<template>
  <div id="app-main-container">
    <transition name="router-fade" mode="out-in">
      <router-view />
    </transition>

    <transition name="router-fade" mode="in-out">
      <c-loading v-show="!portal.isLoaded" />
    </transition>

    <modalDashboard />

    <transition name="slide-fade-up">
      <CookieDisclaimer
        v-if="!isCookieAccepted && !state.closeCookieDisclaimer && hasLgpdContact"
        @update:closeCookieDisclaimer="closeCookieDisclaimer"
      />
    </transition>

    <EnvironmentIndicator v-if="!isProduction" />

    <transition name="router-fade" mode="out-in">
      <SimplificaPublicity
        v-if="brain.user.json.email && brain.company.json.simplificaPublicityLink && !brain.company.moduleOpen"
      />
    </transition>
  </div>
</template>

<script>
import EnvironmentIndicator from '@/components/EnvironmentIndicator/EnvironmentIndicator';
import SimplificaPublicity from '@/components/SimplificaPublicity/SimplificaPublicity';
import CookieDisclaimer from '@/components/CookieDisclaimer/CookieDisclaimer.vue';
import Loading from '@/pages/Loading/Loading';

export default {
  name: 'App',
  components: {
    'c-loading': Loading,
    EnvironmentIndicator,
    SimplificaPublicity,
    CookieDisclaimer,
  },
  data() {
    return {
      portal: this.$portal,
      brain: this.$brain,
      user: this.$user,
      state: {
        closeCookieDisclaimer: false,
      },
    };
  },
  computed: {
    hasLgpdContact() {
      const contact = _.get(brain, 'company.json.lgpd') || {};

      return !!Object.keys(contact).length;
    },
    isProduction() {
      if (_.get(brain, 'company.json.id') === 'local' || _.get(brain, 'company.json.id').includes('stage-')) return false;
      return true;
    },
    isCookieAccepted() {
      return !!this.$cookies.get('cookie-policy-accepted');
    },
  },

  mounted() {
    const clarityId = brain.company.json.id === 'local' || brain.company.json.id.includes('stage-') ? 'h4bdx7t7yt' : 'h2wo5cyv8j';

    if (brain.company.json.id === 'local' || brain.company.json.id.includes('stage-'))
      $('html, body').css('background', '#CFCCC7');
    else $('html, body').css('background', '#EEEEEE');

    this.runClarityScript(clarityId);
    

    this.state.closeCookieDisclaimer = this.isCookieAccepted;
  },
  methods: {
    runClarityScript(clarityId) {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = `https://www.clarity.ms/tag/${i}`;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      }(window, document, 'clarity', 'script', clarityId));
    },
    closeCookieDisclaimer() {
      this.state.closeCookieDisclaimer = true;
    },
  },
};
</script>

<style src="@/app.scss" lang="scss"></style>
